import { Input } from "antd";
import { TextAreaProps } from "antd/lib/input/TextArea";
import { clsx } from "clsx";

import styles from "./RVTextarea.module.scss";

/**
 * Props for `RVTextarea`.
 */
export type RVTextareaProps = TextAreaProps & {
    /** Enables manual vertical resizing on the textarea wrapper */
    shouldResize?: boolean;
};

/**
 * Styled textarea wrapper around Ant Design `Input.TextArea`.
 *
 * @param props Textarea props including Regal resize behavior.
 * @returns Rendered textarea within a style wrapper.
 */
export function RVTextarea({ shouldResize = false, ...props }: RVTextareaProps) {
    return (
        <div
            className={clsx(styles.container, {
                [styles.resize]: shouldResize,
            })}
        >
            <Input.TextArea {...props} />
        </div>
    );
}
